var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-dark btn-sm mr-2",on:{"click":_vm.lockHistory}},[(_vm.historyLocked)?_c('span',[_c('i',{staticClass:"fas fa-lock"})]):_vm._e(),_vm._v(" Lock history\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2537e5d1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HistoryLockButton.vue
// module id = null
// module chunks = 